import formatName from 'I18n/utils/formatName';
import getIn from 'immutable-less/transmute/getIn';
import { emptyPartition, genericFunnel } from 'automation-ui-references/transform/transformGeneric';
export const toEmail = (contact, useProperties = true) => {
  let email;
  if (useProperties) {
    email = getIn(['properties', 'email', 'value'], contact);
  } else {
    email = getIn(['email'], contact);
  }
  return email || '';
};
export const toFullName = (contact, usingProperties = true) => {
  let firstName;
  let lastName;
  if (usingProperties) {
    firstName = getIn(['properties', 'firstname', 'value'], contact);
    lastName = getIn(['properties', 'lastname', 'value'], contact);
  } else {
    firstName = getIn(['firstName'], contact);
    lastName = getIn(['lastName'], contact);
  }
  return formatName({
    firstName,
    lastName
  });
};
export const toFullNameOrEmail = (contact, useProperties = true) => {
  const email = toEmail(contact, useProperties);
  const name = toFullName(contact, useProperties);
  return name || email;
};
export const toFullNameAndEmail = contact => {
  const useProperties = true;
  const name = toFullName(contact, useProperties);
  const email = toEmail(contact, useProperties);
  if (name && !email) {
    return name;
  } else if (!name && email) {
    return email;
  }
  return `${name} (${email})`;
};
const toFullNameAndEmailOption = contact => {
  return {
    text: toFullNameAndEmail(contact),
    value: contact
  };
};
export const toFullNameAndEmailOptions = contacts => {
  return genericFunnel(emptyPartition, [], [], [toFullNameAndEmailOption], contacts);
};